import { t } from '@lingui/core/macro';
import { BaseLayout } from 'components/Layout/BaseLayout/BaseLayout';
import { Products } from 'components/Products/Products';
import { ProductsPageDE } from 'components/ProductsPageDE/ProductsPageDE';
import { useLocale } from 'hooks/useLocale';

export const ProductsPage = () => {
  const { isDE } = useLocale();

  return (
    <BaseLayout showDEFooter pageTitle={t`Products | Introducer Portal`}>
      {isDE ? <ProductsPageDE /> : <Products />}
    </BaseLayout>
  );
};
